/** 无法界定业务属性的公共常量数据 */

// 错误码整合
export const ERROR_CODE = {
  NEW_DEVICE_PHONE: 11001, // 手机登录新设备
  NEW_DEVICE_EMAIL: 11002, // 邮箱登录新设备
  OTP_EMPTY: 11401, // 动态令牌为空
  OTP_ERROR: 11402, // 老虎令牌错误
  CAPTCHA_ERROR: 11017, // 验证码错误
  PASSWORD_TRY_MAX: 11054, // 密码错误次数过多
  VERIFY_CODE_EMPTY: 11041, // 验证码为空
  CAPTCHA_EMPTY: 11011, // 图形验证码为空
  CAPTCHA_EXPIRE: 11013, // 图形验证过期
  IN_MAINTENANCE: 10701, // 系统维护中
  VERIFY_ERROR_CODES: [11042, 11043, 11044], // 邮箱/手机验证码错误
  NEED_GEETEST_CODES: [11011, 11013, 11017], // 需要极验错误码
  TOKEN_INVALID: [10502, 10503, 10504, 10505, 10506, 10507, 10508, 10510], // token 过期
  TRADE_UNAUTHORIZED: 20002 // 交易未授权
}

// omnibus 独有的一些错误
export const ERROR_CODE_OMNIBUS = {
  TRADE_UNAUTHORIZED: 'trade_unauthorized', // 交易未授权
  INVALID: 'invalid', // 无效请求
  NOT_TRADE_TIME: 'not_trade_time', // 非交易时间
  BAD_REQUEST: 'bad_request' // 错误参数
}

// 地理位置（国家）编码
export const LOCATION_CODE = {
  CN: 'CHN', // 中国
  US: 'USA', // 美国
  NZL: 'NZL', // 新西兰
  SGP: 'SGP' // 新加坡
}

export const TIME_ZONE = {
  US: 'America/New_York',
  HK: 'Asia/Hong_Kong',
  UK: 'Europe/London',
  CN: 'Asia/Shanghai',
  SH: 'Asia/Shanghai',
  SZ: 'Asia/Shanghai'
}

// 盘前盘后，接口返回中文，前端映射国际化
export const MARKET_OPEN_MAP = {
  盘前: 'before-market-open',
  盘后: 'after-market-open'
}

// 官网存储的 token 信息
export const TOKEN_COOKIE_NAME = 'TIGER_US_PORTAL_SECURITY'

// COOKIE 存储的配置信息
export const TOKEN_COOKIE_CONF = {
  secure: true,
  expires: 7,
  domain:
    process.env.NODE_ENV === 'production' ? '.tradeup.com' : location.hostname
}

// 新闻媒体只有这几个会直接展示内容，其余的都跳转页面
export const NEWS_MEDIA = ['Reuters', 'Dow Jones', 'Benzinga', 'tiger']

// 置顶新闻是否有版权判断
export const NEWS_TYPES = {
  TYPE1: '1',
  TYPE4: '4'
}

// 轮序周期表达式
export const TIMER_EXPRESSION = {
  PERMISSION: '*/30 * * * * *', // permission权限接口轮询
  MSG_CENTER_TIMER: '*/30 * * * * *', // 消息中心轮询
  HOLDING_LIST: '*/10 * * * * *', // 持仓列表更新
  ASSET_DETAIL: '*/30 * * * * *', // 资产信息
  ASK_BID_OPT: '*/4 * * * * 1-5', // 盘中买卖盘更新
  ASK_BID_STK: '*/2 * * * * 1-5',
  ASK_BID_WAR: '*/4 * * * * 1-5',
  ASK_BID_IOPT: '*/4 * * * * 1-5',
  HOLDING_ORDERS: '*/5 * * * * 1-5', // 未完成订单列表
  HOUR_TRADING: '*/6 * * * * 1-5', // 时图数据
  OPT_DETAIL: '*/4 * * * * 1-5', // 期权详情
  MINUTES_TIMER: '*/6 * * * * 1-5', // 分图数据 - 期权/股票
  FIVE_DAY: '*/30 * * * * 1-5', // 股票5日
  INDICIES_TIMER: '* */1 * * * 1-5', // 大盘状态
  CROSS_MINUTES: '* */1 * * * 1-5', // 分图
  CROSS_DAY: '* */4 * * * 1-5', // 日
  TRADE_TICK: '*/3 * * * * 1-5', // 逐笔列表
  DISCOVERY_TIMER: '*/6 * * * * 1-5', // 发现页更新
  QUOTATION_LIST: '*/5 * * * * 1-5', // 报价列表
  STOCK_DETAIL: '*/3 * * * * 1-5', // 股票详情，个股
  FUNDS_FLOW: '* */1 * * * 1-5', // 资金流程图
  OPTION_CHAIN: '*/6 * * * * 1-5', // 期权链
  MULTIVIEWS_STOCKS: '*/2 * * * * 1-5', // 多图股票
  HISTORY_LIST: '*/3 * * * * 1-5', // 最近刘囊
  RANK_LIST: '*/6 * * * * 1-5', // 分组列表
  WATCHLIST_TIMER: '*/3 * * * * 1-5', // 自选列表
  OPEN_ORDERS: '*/10 * * * * 1-5', // 订单列表
  FLASH_LIST_TIMER: '* */1 * * * *' // 快讯列表更新
}

// 消息中心消息类型
export const MSG_TYPE = {
  TRADE: 19, // 交易
  PRICE: 15, // 股价提醒
  QUOTE: 28, // 个股资讯
  ACTIVITY: 29, // 活动
  SYSTEM: 13 // 系统
}

// 消息中心跳转类型
export const MSG_LINK_TYPE = {
  H5_LINK: 0, // 跳转 H5 链接
  POST: 1, // 跳转帖子
  NEWS: 2, // 新闻
  COMMENT: 3, // 评论
  HIGHLIGHTS: 4, // 要闻
  SHARE_POST: 5, // 晒单帖
  QUOTE: 6, // 个股行情
  FUT: 7, // 期货页面
  VERIFY: 8, // 身份验证
  TEXT: 10, // 纯文本
  BS_ORDER: 11, // 综合订单
  BS_ORDER1: 15, // 综合订单
  OPT_RISK_TEST: 12, // 期权风险测试
  ASSET: 13, // 资金页面
  DEPOSIT: 14, // 入金页面
  IB_ORDER: 16, // 环球订单
  FILLING: 18, // 公告
  LIVE: 20, // 直播
  MARSCO_ORDER: 21, // Marsco 订单
  FUND_RECORD: 22, // 资金记录
  OPT: 23, // 期权详情
  IPO: 33, // 打新
  SUB_NEW_STOCK: 36 // 次新股
}
